import { ScrapingJobStatus } from '../types/types';

import { cn } from '@/shared/utils/cn';

const ScrapingStatusMap = {
  [ScrapingJobStatus.InProgress]: {
    text: 'In progress',
    color: 'bg-destructive',
  },
  [ScrapingJobStatus.Done]: {
    text: 'Done',
    color: 'bg-primary',
  },
};

export function ScrapingJobStatusBadge({ status }: { status: ScrapingJobStatus }) {
  return (
    <div
      className={cn(
        ScrapingStatusMap[status].color,
        'flex rounded-full px-2.5 py-0.5 text-xs leading-4 font-semibold text-white',
      )}
    >
      {ScrapingStatusMap[status].text}
    </div>
  );
}
